// src/components/CustomerView/sections/NaturalPersonView.tsx
import React from 'react';
import InfoField from '../../../Shared/InfoField';
import { ICustomerDetail } from '../../../../types/customer/customerInterfaces';
import DocumentIdentificationField from '../fields/DocumentIdentificationField';

interface Props {
  detail: ICustomerDetail;
}

const v = (x?: string | null) => x ?? '—';

const NaturalPersonView: React.FC<Props> = ({ detail }) => {
  return (
    <>
      {/* Datos Generales */}
      <section className="mb-8">
        <h3 className="text-gray-700 mb-4 text-lg font-semibold dark:text-white">
          Datos Generales
        </h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <InfoField label="Nombre" value={v(detail.name)} />
          <DocumentIdentificationField detail={detail} />
          <InfoField label="NRC" value={v(detail.nrc)} />
          <InfoField label="Nombre Comercial" value={v(detail.tradeName)} />
          <InfoField label="Teléfono" value={v(detail.phone)} />
          <InfoField label="Correo" value={v(detail.email)} />
        </div>
      </section>

      {/* Clasificación */}
      <section className="mb-8">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <InfoField label="Categoría Contribuyente" value={v(detail.taxpayerCategoryName)} />
          <InfoField label="Tipo de Documento Identificación" value={v(detail.documentIdentificationTypeName)} />
          <InfoField label="Actividad Económica" value={v(detail.economicActivityName)} />
        </div>
      </section>

      {/* Dirección */}
      <section>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <InfoField label="País" value={v(detail.countryName)} />
          <InfoField label="Departamento" value={v(detail.departmentName)} />
          <InfoField label="Municipio" value={v(detail.municipalityName)} />
        </div>
        <div className="mt-4">
          <InfoField label="Complemento" value={v(detail.complement)} />
        </div>
      </section>
    </>
  );
};

export default NaturalPersonView;
